import Tooltip from './src/main';

Tooltip.install = function(Vue) {
  Vue.component(Tooltip.name, Tooltip);
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip/index.js